import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LogIn, ShieldCheck } from "lucide-react";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Bem-vindo(a) de volta");
      nav(u.role === "super_admin" ? "/admin" : "/gestor");
    } catch (e) { toast.error(apiError(e)); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16">
      <div className="text-center mb-8">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-indigo-500/15 border border-indigo-500/30 text-indigo-300 text-xs font-semibold uppercase tracking-widest mb-4">
          <ShieldCheck className="w-3.5 h-3.5" /> Painel do Gestor
        </div>
        <h1 className="font-display text-3xl font-bold text-white">Entrar no vixvox</h1>
      </div>
      <Card className="p-8 bg-slate-900/60 border-slate-800">
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-slate-300">E-mail</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="input-login-email" className="bg-slate-800 border-slate-700 text-white" />
          </div>
          <div>
            <Label className="text-slate-300">Senha</Label>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="input-login-password" className="bg-slate-800 border-slate-700 text-white" />
          </div>
          <Button type="submit" disabled={loading} data-testid="btn-login-submit" className="w-full bg-indigo-600 hover:bg-indigo-700 text-white">
            <LogIn className="w-4 h-4 mr-2" /> {loading ? "Entrando…" : "Entrar"}
          </Button>
        </form>
        <div className="mt-6 text-center text-sm text-slate-400">
          Ainda não tem conta? <Link to="/registro" data-testid="link-to-register" className="text-teal-400 hover:underline">Cadastre sua empresa</Link>
        </div>
      </Card>
    </div>
  );
}
